import { createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/chevronLeft.svg'
import _imports_1 from '@/assets/img/search.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-6576f982")

_pushScopeId("data-v-6576f982")
const _hoisted_1 = { class: "genericPadding hasHeader bgWhite" }
const _hoisted_2 = { class: "header withShadow d-flex aling-items-center justify-content-between" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_4 = { class: "searchContainer" }
const _hoisted_5 = /*#__PURE__*/_createVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_6 = { class: "mt-4" }
const _hoisted_7 = { class: "postLoader" }
const _hoisted_8 = { class: "d-flex align-items-center mb-4" }
const _hoisted_9 = { class: "userImage" }
const _hoisted_10 = { class: "fs_13 greyBlue d-block ln_12" }
const _hoisted_11 = { class: "d-flex align-items-center" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _directive_localizedPlaceholder = _resolveDirective("localizedPlaceholder")!
  const _directive_userimage = _resolveDirective("userimage")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", {
        class: "ms-1 me-3 d-flex align-items-center",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
      }, [
        _hoisted_3
      ]),
      _createVNode("div", _hoisted_4, [
        _hoisted_5,
        _withDirectives(_createVNode("input", {
          type: "text",
          onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.search = $event.target.value)),
          class: "searchInput ms-2",
          ref: "searchInput"
        }, null, 544), [
          [_directive_localizedPlaceholder, { key: 'app_cercaRichiesteUtenti', value: 'Cerca tra le richieste utenti...' }]
        ])
      ])
    ]),
    (_ctx.filtered.length == 0)
      ? (_openBlock(), _createBlock(_component_localized_text, {
          key: 0,
          localizedKey: "app_nessunaRichiestaPresente",
          text: "Nessuna richiesta presente al momento",
          class: "fs_14 greyBlue d-block ln_12 text-center mt-4"
        }))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_6, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.filtered, (item, i) => {
        return (_openBlock(), _createBlock("div", {
          class: "postContainer mb-3",
          key: i
        }, [
          _createVNode("div", _hoisted_7, [
            _createVNode("div", _hoisted_8, [
              _withDirectives(_createVNode("div", _hoisted_9, null, 512), [
                [_directive_userimage, _ctx.$store.state.getUserImage(item.from.identifier)]
              ]),
              _createVNode("div", null, [
                _createVNode(_component_localized_text, {
                  localizedKey: "app_richiestaRicevutaDa",
                  text: "Richiesta ricevuta da",
                  class: "fs_10 greyBlue d-block ln_12 mb-1"
                }),
                _createVNode("span", _hoisted_10, _toDisplayString(item.from.name), 1)
              ])
            ]),
            _createVNode("div", _hoisted_11, [
              _createVNode("button", {
                class: "genericButton squareGenericButton bgRed w-100 me-1",
                onClick: ($event: any) => (_ctx.deleteCb(item))
              }, [
                _createVNode(_component_localized_text, {
                  class: "fs_13 white",
                  localizedKey: "app_rifiuta",
                  text: "Rifiuta"
                })
              ], 8, ["onClick"]),
              _createVNode("button", {
                class: "genericButton squareGenericButton w-100 ms-1",
                onClick: ($event: any) => (_ctx.saveCb(item))
              }, [
                _createVNode(_component_localized_text, {
                  class: "fs_13 white",
                  localizedKey: "app_accetta",
                  text: "Accetta"
                })
              ], 8, ["onClick"])
            ])
          ])
        ]))
      }), 128))
    ])
  ]))
})